var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"dashboard-report-frame"}},[(_vm.embeddedURL)?_c('iframe',{attrs:{"title":"Sample Report Demo","width":"100%","height":"100%","src":_vm.embeddedURL,"frameborder":"0","allowFullScreen":"true"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }